import authService from '../auth/auth-service';
import config from '../../config';

const _configAPITecnico = config.configAPITecnico();

class OrdemServicoService {
  async detalhesOS(na, areaAtendimentoID) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(
        `${_configAPITecnico.URI_API}/ordemservico/detalhes/${na}/${areaAtendimentoID}`,
        {
          method: 'GET',
          headers: _headerToken,
        },
      );

      if (response.status === 200) return await response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async listaOrcamentoOS(na, areaAtendimentoID) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(
        `${_configAPITecnico.URI_API}/ordemservico/orcamento?AreaAtendimentoId=${areaAtendimentoID}&NumeroAgendamento=${na}`,
        {
          method: 'GET',
          headers: _headerToken,
        },
      );

      if (response.status === 200) return await response.json();
    } catch (error) {
      console.log(error);
    }
  }


async addProduto(ordemservicoProduto) {
  try {
    const _headerToken = authService.headerAPITecnico();
    const headers = { ...(_headerToken || {}) };

    if (!headers['Content-Type'] && !headers['content-type']) {
      headers['Content-Type'] = 'application/json';
    }

    const body =
      typeof ordemservicoProduto === 'string'
        ? ordemservicoProduto
        : JSON.stringify(ordemservicoProduto);

    const response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/produto`, {
      method: 'POST',
      headers,
      body,
    });

    const rawText = await response.text();

    let parsed = null;
    try {
      parsed = rawText ? JSON.parse(rawText) : null;
    } catch (e) {
      parsed = rawText;
    }

    if (response.status === 200) {
      return { error: false, result: parsed };
    }

    const msg =
      (parsed && typeof parsed === 'object' && (parsed.erro || parsed.message || parsed.error)) ||
      (typeof parsed === 'string' && parsed) ||
      `HTTP ${response.status}`;


    return {
      error: true,
      status: response.status,
      message: msg,
      raw: parsed,
    };
  } catch (error) {
    return {
      error: true,
      message: error?.message || 'Erro ao executar a operação.',
    };
  }
}

  async addVistoria(checkList) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/vistoria`, {
        method: 'Post',
        headers: _headerToken,
        body: checkList,
      });

      if (response.status === 201) return await response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async consultaVistoria(agendamentoID, ordemservicoID) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/vistoria/${agendamentoID}/${ordemservicoID}`, {
        method: 'Get',
        headers: _headerToken,
      });

      if (response.status === 200) return await response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async checkList(imgs) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/vistoriaimg`, {
        method: 'Post',
        headers: _headerToken,
        body: imgs,
      });

      if (response.status === 200) return await response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async observacao(observacao) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/observacao`, {
        method: 'Put',
        headers: _headerToken,
        body: observacao,
      });

      if (response.status === 200)
        return {
          error: false,
          result: response.json(),
        };

      return { error: true, message: 'Não foi possível salvar a OS.' };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um problema ao tentar salvar a OS.',
      };
    }
  }

  async updateAnotacao(anotacao) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/atividadeDeServico/anotacao`, {
        method: 'Put',
        headers: _headerToken,
        body: anotacao,
      });

      if (response.status === 200)
        return {
          error: false,
          result: response.json(),
        };

      return { error: true, message: 'Não foi possível salvar a anotação.' };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um problema ao tentar salvar a anotação.',
      };
    }
  }

  async alteraProduto(ordemservicoProduto, itemOrdemID) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/produto/${itemOrdemID}`, {
        method: 'Put',
        headers: _headerToken,
        body: ordemservicoProduto,
      });

      const resultado = await response.json();

      if (response.status === 200) {
        return {
          error: false,
          result: resultado,
        }
      }
      return {
        error: true,
        message: resultado.erro,
      };
    } catch (error) {
      return {
        error: true,
        message: 'Erro ao executar operação.',
      };
    }
  }

  /** codigoFacial: comprovante de uso único da validação facial (ação FIM), quando a API exigir (428). */
  async atualizar(ordemServico, codigoFacial = null) {
    try {
      const _headerToken = authService.headerAPITecnico();
      if (codigoFacial) _headerToken['X-Facial-Code'] = codigoFacial;
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/atualizar`, {
        method: 'Put',
        headers: _headerToken,
        body: ordemServico,
      });

      return response;
    } catch (error) {
      console.log(error);
    }
  }

  /** codigoFacial: comprovante de uso único da validação facial (ação INICIO), quando a API exigir (428). */
  async iniciarAtividadeDeServico(atividadeId, codigoFacial = null) {
    try {
      const _headerToken = authService.headerAPITecnico();
      if (codigoFacial) _headerToken['X-Facial-Code'] = codigoFacial;
      let response = await fetch(`${_configAPITecnico.URI_API}/atividadeDeServico/${atividadeId}/iniciar`, {
        method: 'Put',
        headers: _headerToken,
      });

      return await response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async terminarAtividadeDeServico(atividadeId) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/atividadeDeServico/${atividadeId}/terminar`, {
        method: 'Put',
        headers: _headerToken,
      });

      if (response.status === 200) return await response.json();
    } catch (error) {
      console.log(error);
    }
  }

  async salvarAnotacao(anotacao) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/atividadeDeServico/anotacao`, {
        method: 'Put',
        headers: _headerToken,
        body: anotacao,
      });

      const data = await response.json();

      let errorsMessage = null;
      if (data.errors) {
        errorsMessage = Object.values(data.errors).map((error) => error);
      }

      if (response.status === 200) return data;

      return {
        error: true,
        message: data.erro || errorsMessage,
      };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um erro ao salvar anotação.',
      };
    }
  }

  async atualizarAnotacao(anotacaoId, anotacao) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/AtividadeDeServico/anotacao/${anotacaoId}`, {
        method: 'PATCH',
        headers: _headerToken,
        body: anotacao,
      });

      const data = await response.json();
      
      let errorsMessage = null;
      if (data.errors) {
        errorsMessage = Object.values(data.errors).map((error) => error);
      }

      if (response.status === 200) return data;

      return {
        error: true,
        message: data.erro || errorsMessage,
      };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um erro ao atualizar anotação.',
      };
    }
  }

  async salvarImagensOS(Imagens, OrdemServicoID) {
    try {
      let dados = {
        Imagens,
        OrdemServicoID,
      };
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/checklistimg`, {
        method: 'Post',
        headers: _headerToken,
        body: JSON.stringify(dados),
      });

      if (response.status === 200)
        return {
          error: false,
          result: response.json(),
        };

      return { error: true, message: 'Não foi possível salvar as imagens, tente novamente mais tarde.' };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um problema ao tentar salvar as imagens.',
      };
    }
  }

  async buscarCorpoImagemOS(OrdemServicoID, nomeImagem) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/imagem/${OrdemServicoID}/${nomeImagem}`, {
        method: 'GET',
        headers: _headerToken,
      });
      if (response.status === 200)
        return {
          error: false,
          result: response.json(),
        };
      return { error: true, message: 'Não foi possível buscar a imagem, tentar novamente mais tarde.' };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um problema ao tentar buscar a imagem.',
      };
    }
  }

  async removeItemOS(itemID, dados) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/removerItem/${itemID}`, {
        method: 'PATCH',
        headers: _headerToken,
        body: dados,
      });

      const data = await response.json();
      let errorsMessage = null;
      if (data.errors) {
        errorsMessage = Object.values(data.errors).map((error) => error);
      }

      if (response.status === 200) return data;

      return {
        error: true,
        message: data.erro || errorsMessage,
      };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um erro ao remover o item.',
      };
    }
  }

  async alteraStatusOS(idOS, dados) {
    try {
      const _headerToken = authService.headerAPITecnico();
      let response = await fetch(`${_configAPITecnico.URI_API}/ordemservico/alterarStatusOS/${idOS}`, {
        method: 'PATCH',
        headers: _headerToken,
        body: dados,
      });

      if (response.status === 200)
        return {
          error: false,
          result: response.json(),
        };

      return { error: true, message: 'Não foi possível alterar a OS.' };
    } catch (error) {
      return {
        error: true,
        message: 'Houve um problema ao tentar alterar a OS.',
      };
    }
  }
}
export default new OrdemServicoService();
